import { Col, Container, Row } from "reactstrap";
import ParticlesAuth from "../../pages/AuthenticationInner/ParticlesAuth";
import { consoleLockup } from "../../helpers/consoleLockup";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import LanguageDropdown from "../../components/Common/LanguageDropdown";

const AuthPageLayout = ({ children }) => {
  const { t, i18n } = useTranslation();
  return (
    <>
      <ParticlesAuth>
        <div
          className="position-absolute top-0 end-0 p-3"
          style={{ zIndex: 10 }}
        >
          <LanguageDropdown variant="light" />
        </div>
        <div className="auth-page-content">
          <Container>
            <Row>
              <Col lg={12}>
                <div className="text-center mt-sm-5 text-white-50">
                  <div>
                    <Link to="/" className="d-inline-block auth-logo">
                      <img
                        src={consoleLockup(i18n.language)}
                        alt="Hububble"
                        height="48"
                      />
                    </Link>
                  </div>
                  <p className="mt-3 fs-15">{t("auth.layout.tagline")}</p>
                </div>
              </Col>
            </Row>
            <Row className="justify-content-center">
              <Col md={8} lg={6} xl={5}>
                {/* insert card or any content here */}
                {children}
              </Col>
            </Row>
          </Container>
        </div>
      </ParticlesAuth>
    </>
  );
};

export default AuthPageLayout;
